module.exports = __webpack_public_path__ + "r-v3/img/ico_dots_horiz.ff0986ad.svg";